<div class="container mb-5">
  <div class="row sticky-title bg-primary text-white">
    <div class="col">    
      <h5 class="p-2 text-center">Musiciens</h5>
    </div>
  </div>
  <div class="row mb-5">
    <div class="col p-0">  
      <table class="table table-striped table-bordered">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Nom</th>
            <th scope="col">Postes (Groupes)</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for(person of persons; track person.person_id) {
              <tr>
                  <td>{{ person.firstname }} {{ person.lastname }} </td>
                  <td class="p-0">
                    <ul class="list-group">
                    @for(job of person.jobs; track job.id) {
                        <li class="list-group-item">
                        <span 
                        [class.text-info]="job.is_holder === Holder.TITULAIRE" 
                        [class.text-warning]="job.is_holder === Holder.REMPLACANT">{{ job.job }} {{ job.group }}</span>
                      </li>
                    }
                    </ul>
                  </td>
                  <td>
                    <div class="d-flex justify-content-between">
                      <button title="Modifier" class="btn btn-primary btn-sm hint--top hint--rounded" (click)="openPerson(person.person_id, $event)" aria-label="Modifier"><i class="fa-solid fa-edit"></i></button>
                      <span class="invisible">x</span>
                      <button title="Supprimer" class="btn btn-danger btn-sm hint--top hint--rounded" (click)="deletePerson(person.person_id)" aria-label="Supprimer"><i class="fa-solid fa-trash"></i></button>
                    </div>
                  </td>
              </tr>
          }
          </tbody>
          <tfoot>
              <tr>
              <td colspan="3" class="text-center">
                  <small>Ajouter une personne :</small>
              </td>
              </tr>
              <tr>
              <td colspan="3">
                  <div class="input-group">            
                    <input type="text" class="form-control" placeholder="Prénom" [(ngModel)]="firstname" />
                    <input type="text" class="form-control" placeholder="Nom" [(ngModel)]="lastname" />
                    <button class="btn btn-outline-success" type="button" (click)="addPerson()">Ajouter</button>
                  </div>
              </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<admin-footer />
